import React, { useState, useEffect } from "react";
import { Card, Form, Input, Button, Spin, App, Typography, Space } from "antd";
import {
  UserOutlined,
  LockOutlined,
  BookOutlined,
  CalculatorOutlined,
  BarChartOutlined,
  FileTextOutlined,
  ReadOutlined,
  DollarOutlined,
} from "@ant-design/icons";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import "./styles.css";

const { Title, Text } = Typography;

// Ảnh logo trong public (VD: public/images/logo-toa.png)
const BRAND_LOGO_PATH = `${process.env.PUBLIC_URL || ""}/images/logo-toa.png`;

const LoginPage = () => {
  const { login, authUser, loading: authLoading } = useAuth();
  const navigate = useNavigate();
  const [localLoading, setLocalLoading] = useState(false);
  const { message } = App.useApp();

  useEffect(() => {
    if (!authLoading && authUser) navigate("/");
  }, [authUser, authLoading, navigate]);

  const onFinish = async (values) => {
    setLocalLoading(true);
    try {
      // KHÔNG còn tham số "remember" nữa
      const result = await login(values.username, values.password);
      if (!result.success) {
        let errorMessage = "ログインに失敗しました。もう一度お試しください。";
        if (result.code === "auth/invalid-credential") {
          errorMessage = "メールアドレスまたはパスワードが正しくありません。";
        }
        message.error(errorMessage);
        setLocalLoading(false);
      }
    } catch {
      message.error("エラーが発生しました。もう一度お試しください。");
      setLocalLoading(false);
    }
  };

  if (authLoading || authUser) {
    return (
      <div className="loading-container light">
        <Spin size="large" />
      </div>
    );
  }

  // Icon nền (màu sáng)
  const bgIcons = [
    { key: "i1", Comp: BookOutlined, left: "8%", top: "16%", delay: "0s", size: 28 },
    { key: "i2", Comp: CalculatorOutlined, left: "20%", top: "70%", delay: "0.5s", size: 30 },
    { key: "i3", Comp: BarChartOutlined, left: "85%", top: "22%", delay: "1s", size: 28 },
    { key: "i4", Comp: FileTextOutlined, left: "75%", top: "68%", delay: "1.6s", size: 26 },
    { key: "i5", Comp: ReadOutlined, left: "60%", top: "12%", delay: "2.1s", size: 28 },
    { key: "i6", Comp: DollarOutlined, left: "34%", top: "30%", delay: "2.8s", size: 26 },
    { key: "i7", Comp: CalculatorOutlined, left: "12%", top: "85%", delay: "3.3s", size: 24 },
    { key: "i8", Comp: BookOutlined, left: "90%", top: "82%", delay: "3.8s", size: 26 },
  ];

  return (
    <div className="login-scene light">
      <div className="bg-grid light" aria-hidden />
      <div className="bg-gradient light" aria-hidden />

      <div className="floating-layer light" aria-hidden>
        {bgIcons.map(({ key, Comp, left, top, delay, size }) => (
          <span
            key={key}
            className="float-icon light"
            style={{ left, top, animationDelay: delay, fontSize: size }}
          >
            <Comp />
          </span>
        ))}
      </div>

      <Card className="login-card light" bordered={false}>
        <div className="brand">
          {/* Logo ảnh với animation */}
          <div className="brand-logo light" role="img" aria-label="TOA Accounting Logo">
            <img className="brand-img" src={BRAND_LOGO_PATH} alt="TOA Accounting Logo" />
            <span className="ring" aria-hidden />
            <span className="shine" aria-hidden />
          </div>

          <div className="brand-texts">
            <Title level={3} className="brand-title light">東亜・簿記練習システム</Title>
            <Text className="brand-sub light">Toa Accounting Practice System</Text>
          </div>
        </div>

        <div className="card-divider light" aria-hidden />

        <Form
          name="normal_login"
          onFinish={onFinish}
          layout="vertical"
          className="login-form light"
        >
          <Form.Item
            label="メールアドレス"
            name="username"
            rules={[{ required: true, message: "メールアドレスを入力してください。" }]}
          >
            <Input
              size="large"
              prefix={<UserOutlined />}
              placeholder="example@school.jp"
              type="email"
              autoComplete="username"
            />
          </Form.Item>

          <Form.Item
            label="パスワード"
            name="password"
            rules={[{ required: true, message: "パスワードを入力してください。" }]}
          >
            <Input.Password
              size="large"
              prefix={<LockOutlined />}
              placeholder="••••••••"
              autoComplete="current-password"
            />
          </Form.Item>

          {/* ĐÃ BỎ: remember & forgot password */}

          <Form.Item style={{ marginTop: 8 }}>
            <Button
              type="primary"
              size="large"
              htmlType="submit"
              className="login-submit light"
              loading={localLoading}
              block
            >
              ログイン
            </Button>
          </Form.Item>
        </Form>

        <Space direction="vertical" size={4} className="footer-help">
          <Text type="secondary" className="muted light">
            © {new Date().getFullYear()} Toa Accounting System
          </Text>
          <Text type="secondary" className="muted light small">
            安全な端末で操作し、ログイン情報は第三者と共有しないでください。
          </Text>
        </Space>
      </Card>
    </div>
  );
};

export default LoginPage;
